module.exports = __webpack_public_path__ + "img/emoji_29.627aeac7.png";